export default "__VITE_PUBLIC_ASSET__40b211a3__"